import i18n from '@/i18n';
import cloneDeep from 'lodash/cloneDeep';
import store from '@/store/store';
import { getAll } from '@/api/formatAffiche/index';
import { getAll as getAllMateriel } from '@/api/gabed/materiel';
import messageErreur from '@/services/general/messageErreur';
import { NO_PAGINATION } from '@/configuration/clientTableConf';

function estFormatAffichePersonnalise(format) {
  return ['visuel', 'impression', 'faconnage', 'expedition'].some((champ) => {
    const fieldReseau = format[champ];
    const fieldAffiche = format.formatAffiche[champ];
    const prestation = fieldReseau.prestationFournisseurId !== fieldAffiche.prestationFournisseurId;
    const produit = fieldReseau.produitPrestationId !== fieldAffiche.produitPrestationId;
    const lieuLivraison = fieldReseau.lieuLivraisonId !== fieldAffiche.lieuLivraisonId;
    return (!!fieldReseau.prestationFournisseurId && prestation)
      || (!!fieldReseau.produitPrestationId && produit)
      || (!!fieldReseau.lieuLivraisonId && lieuLivraison);
  });
}

export default function getFormatsAfficheInformations(produit) {
  const msgs = [];
  const reseauFormatAffiche = produit.produitReseau.formatsAffiche
    .filter((format) => !format.fromFormatAffiche);
  if (!reseauFormatAffiche.length) {
    msgs.push({
      isLink: false,
      libelle: i18n.t('catalogue.formatsAffiche.noFormatsAfficheInProduit'),
    });
  }
  return msgs;
}

export async function checkFormatAfficheIfNewFace(produit) {
  const reseauFormatAfficheIds = produit.produitReseau.formatsAffiche
    .filter((format) => estFormatAffichePersonnalise(format))
    .map((format) => format?.formatAfficheId);
  if (!reseauFormatAfficheIds.length) return false;

  const newFacesMaterielIds = produit.produitReseau.affectationsReseauFace
    .filter((aff) => !aff.id && !!aff.produit.produitFace.face?.materielId)
    .map((aff) => aff.produit.produitFace.face?.materielId);
  if (!newFacesMaterielIds.length) return false;

  const materielsFind = (await getAllMateriel({
    query: {
      societeId: store.getters['societe/societeActiveId'],
      actif: true,
      avecFormatAffiche: true,
      materielsId: newFacesMaterielIds,
    },
  })).data.result.items;
  if (!materielsFind.length) return false;

  const formatsAfficheInFaces = materielsFind.filter((materiel) => {
    return reseauFormatAfficheIds.includes(materiel.materielTechnique.formatAfficheId);
  });
  return !!formatsAfficheInFaces.length;
}

export async function formatAfficheManager(produit) {
  try {
    const formatsAfficheResult = (await getAll({
      limit: NO_PAGINATION,
      query: {
        societeId: store.getters['societe/societeActiveId'],
        avecDonneesEtapeInformation: true,
      },
    })).data.result.items;
    const newFormatsAffiche = formatsAfficheResult.map((f) => {
      return {
        formatAfficheId: f.id,
        formatAffiche: cloneDeep(f),
        visuel: f.visuel,
        impression: f.impression,
        faconnage: f.faconnage,
        expedition: f.expedition,
      };
    });
    newFormatsAffiche.sort((a, b) => {
      return a.formatAffiche.libelle.localeCompare(b.formatAffiche.libelle);
    });
    produit.produitReseau.formatsAffiche = newFormatsAffiche;
  } catch (error) {
    messageErreur(i18n);
    throw error;
  }
}
